(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carousel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', (event) => {
    let currentIndex = 0;
    const carousel = document.querySelector('.logo-carousel');
    const logos = document.querySelectorAll('.logo-item');
    const logoCount = logos.length / 2; // Considering the cloned set of logos
    let scrollAmount = 200; // Default scroll amount for desktop

    function moveCarousel() {
      // Adjust scroll amount for mobile devices
      if (window.innerWidth <= 768) {
        scrollAmount = 400; // Set to 400px to move two logos at a time
      }

      currentIndex = (currentIndex + 1) % logoCount;
      carousel.scrollLeft = currentIndex * scrollAmount;

      // Reset carousel at the end
      if (currentIndex === logoCount - 1) {
        setTimeout(() => {
          carousel.style.scrollBehavior = 'unset';
          carousel.scrollLeft = 0;
          currentIndex = 0;
          setTimeout(() => {
            carousel.style.scrollBehavior = 'smooth';
          }, 0);
        }, 3000);
      }
    }

    if (logos.length > 0) {
      setInterval(moveCarousel, 3000);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["damesly-about-difference-v13"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-dad15-nav]').forEach(function(root){
    var button=root.querySelector('[data-dad15-mobile-button]');var panel=root.querySelector('[data-dad15-mobile-panel]');
    if(button&&panel){var closeMenu=function(){button.setAttribute('aria-expanded','false');panel.hidden=true};button.addEventListener('click',function(){var open=button.getAttribute('aria-expanded')==='true';button.setAttribute('aria-expanded',open?'false':'true');panel.hidden=open});panel.addEventListener('click',function(event){if(event.target.closest('a'))closeMenu()});document.addEventListener('click',function(event){if(!root.contains(event.target)){closeMenu();root.querySelectorAll('details[open]').forEach(function(item){item.removeAttribute('open')})}});document.addEventListener('keydown',function(event){if(event.key==='Escape'){closeMenu();root.querySelectorAll('details[open]').forEach(function(item){item.removeAttribute('open')})}})}
  });
  var hideTidioLabel=function(){var host=document.querySelector('#tidio-chat');var label=host&&host.shadowRoot?host.shadowRoot.querySelector('[data-testid="widgetLabel"]'):null;if(label){label.style.setProperty('display','none','important');return true}return false};var tidioTries=0;var tidioTimer=window.setInterval(function(){tidioTries+=1;if(hideTidioLabel()||tidioTries>40){window.clearInterval(tidioTimer)}},500);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["damesly-about-us-v13"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-dau15-nav]').forEach(function(root){
    var button=root.querySelector('[data-dau15-mobile-button]');var panel=root.querySelector('[data-dau15-mobile-panel]');
    if(button&&panel){var closeMenu=function(){button.setAttribute('aria-expanded','false');panel.hidden=true};button.addEventListener('click',function(){var open=button.getAttribute('aria-expanded')==='true';button.setAttribute('aria-expanded',open?'false':'true');panel.hidden=open});panel.addEventListener('click',function(event){if(event.target.closest('a'))closeMenu()});document.addEventListener('click',function(event){if(!root.contains(event.target)){closeMenu();root.querySelectorAll('details[open]').forEach(function(item){item.removeAttribute('open')})}});document.addEventListener('keydown',function(event){if(event.key==='Escape'){closeMenu();root.querySelectorAll('details[open]').forEach(function(item){item.removeAttribute('open')})}})}
  });
  var hideTidioLabel=function(){var host=document.querySelector('#tidio-chat');var label=host&&host.shadowRoot?host.shadowRoot.querySelector('[data-testid="widgetLabel"]'):null;if(label){label.style.setProperty('display','none','important');return true}return false};var tidioTries=0;var tidioTimer=window.setInterval(function(){tidioTries+=1;if(hideTidioLabel()||tidioTries>40){window.clearInterval(tidioTimer)}},500);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["damesly-commercial-page-v13"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-dcp13]').forEach(function(root) {
    var mobileButton = root.querySelector('[data-dcp13-mobile-button]');
    var mobilePanel = root.querySelector('[data-dcp13-mobile-panel]');
    if (mobileButton && mobilePanel && !mobileButton.hasAttribute('data-dcp13-bound')) {
      mobileButton.setAttribute('data-dcp13-bound', 'true');
      var closeMobileMenu = function(returnFocus) {
        mobileButton.setAttribute('aria-expanded', 'false');
        mobilePanel.hidden = true;
        if (returnFocus) mobileButton.focus();
      };
      mobileButton.addEventListener('click', function() {
        var open = mobileButton.getAttribute('aria-expanded') === 'true';
        mobileButton.setAttribute('aria-expanded', open ? 'false' : 'true');
        mobilePanel.hidden = open;
      });
      mobilePanel.addEventListener('click', function(event) {
        if (event.target.closest('a')) closeMobileMenu(false);
      });
      document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape' && !mobilePanel.hidden) closeMobileMenu(true);
      });
      document.addEventListener('click', function(event) {
        if (!mobilePanel.hidden && !root.contains(event.target)) closeMobileMenu(false);
      });
    }

    var pageKind = root.getAttribute('data-dcp13-page-kind');
    var modeByKind = {
      custom: 'custom_trip',
      hosted: 'hosted_trip',
      advisor: 'travel_advisor'
    };

    var analyticsAllowed = function() {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      return Boolean(
        privacy &&
        typeof privacy.analyticsProcessingAllowed === 'function' &&
        privacy.analyticsProcessingAllowed()
      );
    };

    var measurementFor = function(link) {
      var slot = link.getAttribute('data-dcp13-track');
      var href = link.getAttribute('href') || '';
      var journeyMode = modeByKind[pageKind];

      if (slot === 'secondary' && href.indexOf('calendly.com') !== -1 && journeyMode) {
        return {
          event: 'human_help_click',
          journey_outcome: journeyMode,
          page_location_path: window.location.pathname,
          help_type: 'scheduler'
        };
      }

      if (slot === 'secondary' && href.indexOf('/collections/destinations') !== -1) {
        return {
          event: 'decision_path_selected',
          journey_mode: 'group_trips',
          page_location_path: window.location.pathname
        };
      }

      if ((slot === 'primary' || slot === 'close') && pageKind === 'custom') {
        return {
          event: 'decision_path_selected',
          journey_mode: 'custom_trip',
          page_location_path: window.location.pathname
        };
      }

      if ((slot === 'primary' || slot === 'close') && (pageKind === 'hosted' || pageKind === 'advisor')) {
        return {
          event: 'b2b_path_selected',
          journey_mode: journeyMode,
          page_location_path: window.location.pathname
        };
      }

      return null;
    };

    root.addEventListener('click', function(event) {
      var link = event.target.closest('[data-dcp13-track]');
      if (!link || !root.contains(link) || !analyticsAllowed()) return;

      var measurement = measurementFor(link);
      if (!measurement) return;

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(measurement);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["damesly-contact-routing-v13"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-damesly-contact-routing]');

    roots.forEach((root) => {
      const sourceField = root.querySelector('[data-dcr13-source]');
      const inquiryField = root.querySelector('[data-dcr13-inquiry]');
      if (!sourceField || !inquiryField) return;

      const sourceToInquiry = {
        'custom-trip-planning': 'Custom/private travel',
        'hosted-trips': 'Hosted creator/community/organization partnership',
        'travel-agents': 'Travel advisor',
        'referral-program': 'Referral interest'
      };
      const inquiryKeys = {
        general: 'General',
        custom: 'Custom/private travel',
        hosted: 'Hosted creator/community/organization partnership',
        advisor: 'Travel advisor',
        referral: 'Referral interest'
      };
      const params = new URLSearchParams(window.location.search);
      let source = params.get('source');

      if (!Object.prototype.hasOwnProperty.call(sourceToInquiry, source)) {
        try {
          const referrer = new URL(document.referrer);
          if (referrer.origin === window.location.origin) {
            source = referrer.pathname.split('/').filter(Boolean).pop();
          }
        } catch (error) {
          source = null;
        }
      }

      if (!Object.prototype.hasOwnProperty.call(sourceToInquiry, source)) {
        source = 'contact-page';
      }

      sourceField.value = source;

      const requestedInquiry = inquiryKeys[params.get('inquiry')];
      if (requestedInquiry) {
        inquiryField.value = requestedInquiry;
      } else if (sourceToInquiry[source]) {
        inquiryField.value = sourceToInquiry[source];
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["damesly-v13-home-video-focus"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-dv13]').forEach(function(root){
    var menuButton=root.querySelector('[data-menu-toggle]');var menu=root.querySelector('.dv13__nav');if(menuButton&&menu){menuButton.addEventListener('click',function(){var open=menu.classList.toggle('is-open');menuButton.setAttribute('aria-expanded',String(open));menuButton.textContent=open?'Close':'Menu'})}
    root.querySelectorAll('[data-filter]').forEach(function(button){button.addEventListener('click',function(){var filter=button.dataset.filter;root.querySelectorAll('[data-filter]').forEach(function(item){var active=item===button;item.classList.toggle('is-active',active);item.setAttribute('aria-pressed',String(active))});root.querySelectorAll('[data-year]').forEach(function(card){var show=filter==='all'?card.dataset.year!=='past':card.dataset.year===filter;card.hidden=!show;card.style.display=show?'block':'none'})})});
    var reviewCard=root.querySelector('[data-review-card]');if(reviewCard){var reviews=[{name:'Julie J.',text:'Our tour was very well run. There was never a moment we felt unsupported.'},{name:'S. P.',text:'An absolutely fantastic experience! The trip was so well planned from accommodations to tours.'},{name:'Shyla E.',text:'10 out of 10 recommend this tour company. Every aspect was handled down to the smallest detail.'},{name:'Carla G.',text:'We did a private trip to Italy. It was absolutely incredible!'},{name:'Elizabeth S.',text:'Loved traveling with a small group of independent, adventurous, like-minded women!'}];var reviewIndex=0;var reviewPaused=false;var pauseButton=reviewCard.querySelector('[data-review-pause]');var setPaused=function(paused){reviewPaused=paused;pauseButton.textContent=paused?'▶':'–';pauseButton.setAttribute('aria-label',paused?'Resume Google reviews':'Pause Google reviews');pauseButton.setAttribute('aria-pressed',String(paused))};var showReview=function(){reviewCard.querySelector('[data-review-text]').textContent='“'+reviews[reviewIndex].text+'”';reviewCard.querySelector('[data-review-name]').textContent=reviews[reviewIndex].name;reviewCard.querySelector('[data-review-count]').textContent=(reviewIndex+1)+'/5'};var moveReview=function(step){reviewIndex=(reviewIndex+step+reviews.length)%reviews.length;showReview()};reviewCard.querySelector('[data-review-prev]').addEventListener('click',function(){moveReview(-1)});reviewCard.querySelector('[data-review-next]').addEventListener('click',function(){moveReview(1)});pauseButton.addEventListener('click',function(){setPaused(!reviewPaused)});reviewCard.addEventListener('mouseenter',function(){setPaused(true)});reviewCard.addEventListener('mouseleave',function(){setPaused(false)});reviewCard.addEventListener('focusin',function(){setPaused(true)});reviewCard.addEventListener('focusout',function(event){if(!reviewCard.contains(event.relatedTarget)){setPaused(false)}});if(!window.matchMedia('(prefers-reduced-motion: reduce)').matches){window.setInterval(function(){if(!reviewPaused&&!document.hidden){moveReview(1)}},8000)}}
    var dialog=root.querySelector('[data-popup]');var opens=root.querySelectorAll('[data-popup-open]');var close=root.querySelector('[data-popup-close]');if(dialog&&opens.length&&close){var storageKey='damesly_v13_newsletter_prompt_until';var promptDelay=9000;var promptInterval=1209600000;var showDialog=function(){if(!dialog.open){dialog.showModal()}};opens.forEach(function(open){open.addEventListener('click',showDialog)});close.addEventListener('click',function(){dialog.close()});dialog.addEventListener('click',function(event){if(event.target===dialog){dialog.close()}});if(!window.Shopify||!window.Shopify.designMode){var promptUntil=0;try{promptUntil=Number(window.localStorage.getItem(storageKey)||0)}catch(error){}if(Date.now()>=promptUntil){window.setTimeout(function(){if(document.visibilityState==='visible'&&!dialog.open){showDialog();try{window.localStorage.setItem(storageKey,String(Date.now()+promptInterval))}catch(error){}}},promptDelay)}}}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["damesly-v13-home-video-full"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-dv13]').forEach(function(root){
    var menuButton=root.querySelector('[data-menu-toggle]');var menu=root.querySelector('.dv13__nav');if(menuButton&&menu){menuButton.addEventListener('click',function(){var open=menu.classList.toggle('is-open');menuButton.setAttribute('aria-expanded',String(open));menuButton.textContent=open?'Close':'Menu'})}
    var aboutGroup=root.querySelector('.dv13__nav-group');if(aboutGroup&&window.matchMedia('(min-width:901px) and (hover:hover)').matches){aboutGroup.addEventListener('mouseenter',function(){aboutGroup.open=true});aboutGroup.addEventListener('mouseleave',function(){if(!aboutGroup.contains(document.activeElement)){aboutGroup.open=false}});aboutGroup.addEventListener('focusin',function(){aboutGroup.open=true});aboutGroup.addEventListener('focusout',function(event){if(!aboutGroup.contains(event.relatedTarget)){aboutGroup.open=false}})}
    root.querySelectorAll('[data-filter]').forEach(function(button){button.addEventListener('click',function(){var filter=button.dataset.filter;root.querySelectorAll('[data-filter]').forEach(function(item){var active=item===button;item.classList.toggle('is-active',active);item.setAttribute('aria-pressed',String(active))});root.querySelectorAll('[data-year]').forEach(function(card){var show=filter==='all'?card.dataset.year!=='past':card.dataset.year===filter;card.hidden=!show;card.style.display=show?'block':'none'})})});
    var reviewCard=root.querySelector('[data-review-card]');if(reviewCard){var reviews=[{name:'Julie J.',text:'Our tour was very well run. There was never a moment we felt unsupported.'},{name:'S. P.',text:'An absolutely fantastic experience! The trip was so well planned from accommodations to tours.'},{name:'Shyla E.',text:'10 out of 10 recommend this tour company. Every aspect was handled down to the smallest detail.'},{name:'Carla G.',text:'We did a private trip to Italy. It was absolutely incredible!'},{name:'Elizabeth S.',text:'Loved traveling with a small group of independent, adventurous, like-minded women!'}];var reviewIndex=0;var reviewPaused=false;var pauseButton=reviewCard.querySelector('[data-review-pause]');var setPaused=function(paused){reviewPaused=paused;pauseButton.textContent=paused?'▶':'–';pauseButton.setAttribute('aria-label',paused?'Resume Google reviews':'Pause Google reviews');pauseButton.setAttribute('aria-pressed',String(paused))};var showReview=function(){reviewCard.querySelector('[data-review-text]').textContent='“'+reviews[reviewIndex].text+'”';reviewCard.querySelector('[data-review-name]').textContent=reviews[reviewIndex].name;reviewCard.querySelector('[data-review-count]').textContent=(reviewIndex+1)+'/5'};var moveReview=function(step){reviewIndex=(reviewIndex+step+reviews.length)%reviews.length;showReview()};reviewCard.querySelector('[data-review-prev]').addEventListener('click',function(){moveReview(-1)});reviewCard.querySelector('[data-review-next]').addEventListener('click',function(){moveReview(1)});pauseButton.addEventListener('click',function(){setPaused(!reviewPaused)});reviewCard.addEventListener('mouseenter',function(){setPaused(true)});reviewCard.addEventListener('mouseleave',function(){setPaused(false)});reviewCard.addEventListener('focusin',function(){setPaused(true)});reviewCard.addEventListener('focusout',function(event){if(!reviewCard.contains(event.relatedTarget)){setPaused(false)}});if(!window.matchMedia('(prefers-reduced-motion: reduce)').matches){window.setInterval(function(){if(!reviewPaused&&!document.hidden){moveReview(1)}},8000)}}

    // Michael September 22: personality quiz after 20 seconds of browsing from the first scroll.
    var quizDialog=root.querySelector('[data-personality-popup]');
    if(quizDialog&&(!window.Shopify||!window.Shopify.designMode)){
      var quizSeenKey='damesly_personality_prompt_seen';var quizSeen=false;var quizPending=false;
      try{quizSeen=window.sessionStorage.getItem(quizSeenKey)==='1'}catch(error){}
      var showPersonality=function(){
        if(!quizPending||quizSeen||document.visibilityState!=='visible'||document.querySelector('dialog[open]'))return;
        quizPending=false;quizSeen=true;quizDialog.querySelector('iframe').src=quizDialog.querySelector('iframe').dataset.src;
        quizDialog.showModal();try{window.sessionStorage.setItem(quizSeenKey,'1')}catch(error){}
      };
      quizDialog.querySelector('[data-personality-close]').addEventListener('click',function(){quizDialog.close()});
      quizDialog.addEventListener('click',function(event){if(event.target===quizDialog){var b=quizDialog.getBoundingClientRect();if(event.clientX<b.left||event.clientX>b.right||event.clientY<b.top||event.clientY>b.bottom)quizDialog.close()}});
      if(!quizSeen){
        window.addEventListener('scroll',function(){window.setTimeout(function(){quizPending=true;showPersonality()},20000)},{once:true,passive:true});
        root.querySelectorAll('dialog').forEach(function(other){other.addEventListener('close',showPersonality)});
        document.addEventListener('visibilitychange',showPersonality);
      }
    }

    var dialog=root.querySelector('[data-popup]');var opens=root.querySelectorAll('[data-popup-open]');var close=root.querySelector('[data-popup-close]');if(dialog&&opens.length&&close){var storageKey='damesly_v13_newsletter_prompt_until';var promptDelay=15000;var promptInterval=1209600000;var showDialog=function(){if(!dialog.open){dialog.showModal()}};opens.forEach(function(open){open.addEventListener('click',showDialog)});close.addEventListener('click',function(){dialog.close()});dialog.addEventListener('click',function(event){if(event.target===dialog){dialog.close()}});if(!window.Shopify||!window.Shopify.designMode){var promptUntil=0;try{promptUntil=Number(window.localStorage.getItem(storageKey)||0)}catch(error){}if(Date.now()>=promptUntil){window.setTimeout(function(){if(document.visibilityState==='visible'&&!dialog.open){showDialog();try{window.localStorage.setItem(storageKey,String(Date.now()+promptInterval))}catch(error){}}},promptDelay)}}}
  });

  document.addEventListener('click',function(event){document.querySelectorAll('.dv13__nav-group[open]').forEach(function(group){if(!group.contains(event.target)){group.removeAttribute('open')}})});
  var hideTidioLabel=function(){var host=document.querySelector('#tidio-chat');var label=host&&host.shadowRoot?host.shadowRoot.querySelector('[data-testid="widgetLabel"]'):null;if(label){label.style.setProperty('display','none','important');return true}return false};var tidioTries=0;var tidioTimer=window.setInterval(function(){tidioTries+=1;if(hideTidioLabel()||tidioTries>40){window.clearInterval(tidioTimer)}},500);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["damesly-v13-parity"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-dv13]').forEach(function(root){
    var menuButton=root.querySelector('[data-menu-toggle]');var menu=root.querySelector('.dv13__nav');if(menuButton&&menu){menuButton.addEventListener('click',function(){var open=menu.classList.toggle('is-open');menuButton.setAttribute('aria-expanded',String(open));menuButton.textContent=open?'Close':'Menu'})}
    root.querySelectorAll('[data-filter]').forEach(function(button){button.addEventListener('click',function(){var filter=button.dataset.filter;root.querySelectorAll('[data-filter]').forEach(function(item){var active=item===button;item.classList.toggle('is-active',active);item.setAttribute('aria-pressed',String(active))});root.querySelectorAll('[data-year]').forEach(function(card){var show=filter==='all'?card.dataset.year!=='past':card.dataset.year===filter;card.hidden=!show;card.style.display=show?'block':'none'})})});
    var reviewCard=root.querySelector('[data-review-card]');if(reviewCard){var reviews=[{name:'Julie J.',text:'Our tour was very well run. There was never a moment we felt unsupported.'},{name:'S. P.',text:'An absolutely fantastic experience! The trip was so well planned from accommodations to tours.'},{name:'Shyla E.',text:'10 out of 10 recommend this tour company. Every aspect was handled down to the smallest detail.'},{name:'Carla G.',text:'We did a private trip to Italy. It was absolutely incredible!'},{name:'Elizabeth S.',text:'Loved traveling with a small group of independent, adventurous, like-minded women!'}];var reviewIndex=0;var reviewPaused=false;var pauseButton=reviewCard.querySelector('[data-review-pause]');var setPaused=function(paused){reviewPaused=paused;pauseButton.textContent=paused?'▶':'–';pauseButton.setAttribute('aria-label',paused?'Resume Google reviews':'Pause Google reviews');pauseButton.setAttribute('aria-pressed',String(paused))};var showReview=function(){reviewCard.querySelector('[data-review-text]').textContent='“'+reviews[reviewIndex].text+'”';reviewCard.querySelector('[data-review-name]').textContent=reviews[reviewIndex].name;reviewCard.querySelector('[data-review-count]').textContent=(reviewIndex+1)+'/5'};var moveReview=function(step){reviewIndex=(reviewIndex+step+reviews.length)%reviews.length;showReview()};reviewCard.querySelector('[data-review-prev]').addEventListener('click',function(){moveReview(-1)});reviewCard.querySelector('[data-review-next]').addEventListener('click',function(){moveReview(1)});pauseButton.addEventListener('click',function(){setPaused(!reviewPaused)});reviewCard.addEventListener('mouseenter',function(){setPaused(true)});reviewCard.addEventListener('mouseleave',function(){setPaused(false)});reviewCard.addEventListener('focusin',function(){setPaused(true)});reviewCard.addEventListener('focusout',function(event){if(!reviewCard.contains(event.relatedTarget)){setPaused(false)}});if(!window.matchMedia('(prefers-reduced-motion: reduce)').matches){window.setInterval(function(){if(!reviewPaused&&!document.hidden){moveReview(1)}},8000)}}
    var dialog=root.querySelector('[data-popup]');var opens=root.querySelectorAll('[data-popup-open]');var close=root.querySelector('[data-popup-close]');if(dialog&&opens.length&&close){var storageKey='damesly_v13_newsletter_prompt_until';var promptDelay=9000;var promptInterval=1209600000;var showDialog=function(){if(!dialog.open){dialog.showModal()}};opens.forEach(function(open){open.addEventListener('click',showDialog)});close.addEventListener('click',function(){dialog.close()});dialog.addEventListener('click',function(event){if(event.target===dialog){dialog.close()}});if(!window.Shopify||!window.Shopify.designMode){var promptUntil=0;try{promptUntil=Number(window.localStorage.getItem(storageKey)||0)}catch(error){}if(Date.now()>=promptUntil){window.setTimeout(function(){if(document.visibilityState==='visible'&&!dialog.open){showDialog();try{window.localStorage.setItem(storageKey,String(Date.now()+promptInterval))}catch(error){}}},promptDelay)}}}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
